import { hexToRgb, rgbToHex } from 'utilities/color';

qtee.customDesign = window.qtee.customDesign || {};

/** Text Colors view */
qtee.customDesign.TextColorsView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/text-color',
	ui: {
		swatches: '.colorSwatch',
		scroller: '.scrollable',
		checks: '.spriteColorCheck',
		back: '.back'
	},
	events: {
		'click @ui.swatches': 'swatchClick',
		'click @ui.back': 'backClick'
	},
	modelEvents: {
		change: 'render'
	},
	checkSwitch () {

		let currentColor = qtee.customDesign.canvas.getSelected().element.getFill();

		currentColor = rgbToHex(currentColor.match(/\d+/g));
		const swatch = this.ui.scroller.find(`[data-color="${currentColor.substr('1')}"]`);
		swatch.find('.spriteColorCheck').removeClass('hidden');

		return swatch.parent().index();

	},
	onAttach () {

		const that = this;

		// init scrollables and navigator
		this.ui.scroller.scrollable({ touch: true });
		this.ui.scroller.navigator();

		setTimeout(() => {

			that.ui.scroller.scrollable().seekTo(that.checkSwitch(), 0);

		}, 0);

	},
	backClick () {

		$(qtee.customDesign).trigger('selected.elements.canvas', qtee.customDesign.canvas.getSelected());

	},
	swatchClick (e) {

		const that = this;
		const $e = $(e.currentTarget);
		const el = qtee.customDesign.canvas.getSelected();
		const color = hexToRgb($e.data('color').toString());

		qtee.customDesign.settings.newEl.text.fill = {
			r: color[0],
			g: color[1],
			b: color[2]
		};

		if (el) {

			el.element.setFill(`rgb(${color[0]},${color[1]},${color[2]})`).then(
				(element) => {

					$(qtee.customDesign).trigger('transformed.elements.canvas', element);
					that.ui.checks.addClass('hidden');
					that.checkSwitch();

				},
				(reason) => {

					throw reason;

				}
			);

		}

	}
});
